<app-dialog-header
  [title]="'Confirm Efficiency Changes'"
  (closeClicked)="cancel()"
>
</app-dialog-header>

<div mat-dialog-content>
  <div class="warning-message">
    <mat-icon color="warn">warning</mat-icon>
    <p>
      Warning: Changes to a resource's efficiency affect the duration of their
      booked work.
    </p>
    <p>
      <strong>Important:</strong> These changes will not be applied to the
      solver until the solve state is reloaded from the database.
    </p>
    @if (isAdmin) {
      <p>
        <strong>Note for Administrators:</strong> Reloading the solve state can
        cause temporary disruption as the solver may be unavailable for a few
        minutes. Please plan accordingly.
      </p>
    } @else {
      <p>
        <strong>Note:</strong> If you need these changes applied urgently,
        please contact your system administrator to reload the solve state.
      </p>
    }
    <p>Do you want to continue with saving these changes?</p>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="confirm()">Confirm</button>
</div>
